<script lang="ts" setup>
import { computed, type TransitionProps, type VNode } from 'vue';
import useTransitionBase from '../VTransitionBase/composables/transitionBase';
import type { Props } from '../VTransitionBase/types';
import { propsDefaults } from '../VTransitionBase/utils';

const props = withDefaults(
  defineProps<
    Props & {
      appear?: TransitionProps['appear'];
      /**
       * @deprecated gebruik v-if zoals je ook bij een <Transition> component zou doen
       */
      visible?: boolean;
    }
  >(),
  {
    ...propsDefaults,
    visible: true,
  },
);

const emit = defineEmits<{
  'after-enter': [el: Element];
}>();

const { classAttributes, needsContainers } = useTransitionBase(() => props);

const slots = defineSlots();

const slotChild = computed(() => {
  if (!slots.default) {
    return undefined;
  }

  const defaultSlots = slots.default();

  if (!Array.isArray(defaultSlots) || defaultSlots.length !== 1) {
    return undefined;
  }

  return defaultSlots[0] as VNode;
});
</script>

<template>
  <Transition
    :appear="props.appear"
    :mode="props.mode"
    v-bind="classAttributes"
    @after-enter="(el) => emit('after-enter', el)"
  >
    <div v-if="needsContainers && slotChild?.children !== 'v-if'" v-show="props.visible">
      <div>
        <slot></slot>
      </div>
    </div>

    <slot v-else></slot>
  </Transition>
</template>
